import * as React from 'react';

import InfluencerCreatorNetworkListContext from '../context/InfluencerCreatorNetworkListContext';
import InfluencerCreatorNetworkListItem from './item/InfluencerCreatorNetworkListItem';
import InfluencerCreatorNetworkListConnections from './connections/InfluencerCreatorNetworkListConnections';

import './influencer-creator-network-list-items.scss';

import type { NetworkGraphNodeRaw } from 'types';

type Props = {
  list: Array<NetworkGraphNodeRaw>,
  connections: Array<NetworkGraphNodeRaw>
};

const InfluencerCreatorNetworkListItems = (
  {
    list,
    connections
  }: Props
): JSX.Element => {
  const context = React.useContext(InfluencerCreatorNetworkListContext);
  const filteredList = list.filter(item => item.symbolSize !== 1); // main node
  const filteredConnections = (connections || []).filter(item => item.symbolSize !== 1); // main node

  return (
    <div className="influencer-creator-network-list-items">
      <div className="influencer-creator-network-list-items__content">
        {
          filteredList.map(item => {
            const isConnectionsLoading = Boolean(
              context?.expandedId === item.profileId
              && context?.isLoading.connections
            );

            return (
              <React.Fragment key={`influencer-creator-network-list__item--${item.id}`}>
                <InfluencerCreatorNetworkListItem
                  item={item}
                  isConnectionsLoading={isConnectionsLoading}
                />
                <InfluencerCreatorNetworkListConnections
                  connections={filteredConnections}
                  influencerProfileId={item.profileId}
                  parentInfluencerName={item.profileName}
                  isLoading={isConnectionsLoading}
                />
              </React.Fragment>
            );
          })
        }
      </div>
    </div>
  );
};

export default InfluencerCreatorNetworkListItems;
